import React,{useState, useEffect,useCallback,useRef} from 'react'
import { useForm } from 'react-hook-form'
import { useSelector, useDispatch } from 'react-redux'
import { useAlert } from 'react-alert'
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Input from './Common/Atoms/Input'
import { InputGroup, SelectGroup, HiddenInput } from './Common/CommonInputGroup'
import Button from './Common/Atoms/NormalButton'
import { GetApi ,MultipartApi} from './Common/ApiAxios'
import { SetLoadSpinner } from './Common/Slice/LoadSpinnerSlice'
import ErrorHandling from './Common/ErrorHandling'

import { dateFormat} from './Common/Utilties/LaborUtility'
import * as regex from './Common/Regex'
const useStyles = makeStyles((theme) => ({
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

const ContentWrap = styled.div`
  display: flex;
  flex-direction: column;
`

const TitleWrap = styled.div`
  font-size: 24px;
  display: flex;
  padding: 1vw;
  font-weight: bold;
`
const RadioWrap = styled.div`
  display: flex;
  font-size: 18px;
  justify-content: center;
  padding: 10px;
`
const FormWrap = styled.form`
  display: flex;
`
const TableWrap = styled.div`
  display: flex;
  padding: 1vw;
`

const ButtonsWrap = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 1vw;
`

const SettingMenu = ({ open, onCloseFunc}) => {
  const { register, handleSubmit, getValues, setError, setValue, watch, reset, errors, control } = useForm({ validateCriteriaMode: 'all' })
  const classes = useStyles();
  const alert = useAlert()
  const dispatch = useDispatch()
  const [postList,setPostList] = useState(new Array())
  const [rows,setRows] = useState(<></>)
  const [canOpenDialog, setCanOpenDialog] = useState(false);

  const [settingList, setSettingList] = useState(null)

  const [companyDepartmentId, setCompanyDepartmentId] = useState(null)
  const [companyId, setCompanyId] = useState(null)
  const [companyName, setCompanyName] = useState(null)
  const [companyDepartmentName,setCompanyDepartmentName]=useState(null)
  const [departmentList,setDepartmentList] = useState(null)

  const [checked,setChecked]=useState(true)
  const [closingChecked,setClosingChecked]=useState(null)
  const [closingDate,setClosingDate]=useState(null)

  //ラジオボタン変更処理
  const handleClosingCheckChange = () => {
    if(!closingChecked){
      let num = document.getElementById('closingDate');
      num.value = undefined;
      setClosingDate(null)
    }
    setClosingChecked(!closingChecked)
  };
  // POST・PUT処理
  const onSubmit = () => {
    async function sendPost (requestBody, data) {
        var result
        dispatch(SetLoadSpinner(true))
        console.log(data)
        result = 
          await MultipartApi('/api/updateSettingAttendance','PUT', requestBody, data)
        
        if (!ErrorHandling(result, alert)) {
            alert.success('保存しました')
        }
        dispatch(SetLoadSpinner(false))
    }

    let data ={
        closingDate:(closingChecked)?99:closingDate,
    }
    if(!closingChecked && !closingDate){
      window.alert("勤怠締日を入力してください")
      return
    }
    const submitData = new window.FormData()
    submitData.append('formData', new window.Blob([JSON.stringify(data)], { type: 'application/json' }))
    sendPost(submitData, data)
  }

  //勤怠設定取得処理
  const setSetting=()=>{
      const serachClosingDate= async()=>{
        const result = await GetApi('/api/settingClosingDate')
        console.log(result)
        if (result.errorDetail || !result.data) {
          ErrorHandling(result, alert)
          return null
        }else{
          if(result.data==99){
            setClosingChecked(true)
          }else{
            setClosingChecked(false)
            setClosingDate(result.data)
          }
        }
      }
      serachClosingDate()
  }
  useEffect(() => {
    setSetting()
    // 必要なデータが更新された場合のみ実行
    // eslint-disable-next-line
  }, [])

  //ラジオボタン変更処理
  const onNumberChange = (e) => {
    var num = e.target.value
    if(num > 0 && num<32){
      setClosingDate(e.target.value)
    }
    else{
      setClosingDate(1)
      e.target.value=1
    }
      
  };
  const onSubmitHandale=()=>{}

  if(closingChecked==null) return<></>
  return (
    <Modal
      open={open}
      onClose={onCloseFunc}
      aria-labelledby='設定'
      aria-describedby='設定ダイアログ'
      style={{display:'flex',alignItems:'center',justifyContent:'center'}}
    >
    <FormWrap onSubmit={handleSubmit(onSubmitHandale)} className='h-dsm'>
    <div className={classes.paper}>
      <ContentWrap>
      <TitleWrap>
          <label>設定</label>
      </TitleWrap>
      </ContentWrap>
      <TableWrap>
        <label style={{marginTop:'6px',marginLeft:'0px',width:'6rem' ,fontWeight: 'bold',fontSize:'18px'}}>締日設定</label>
        <RadioWrap>
            <input type="radio" value={0} name="closing" checked={closingChecked} onChange={()=>handleClosingCheckChange()}/>月末締め
            <input type="radio" value={1} name="closing" checked={!closingChecked} onChange={()=>handleClosingCheckChange()}/>
        </RadioWrap>
        <Input type='number' name='closingDate' id='closingDate' disabled={closingChecked} onBlur={(e)=>onNumberChange(e)}
           width='4rem'
           margin='6px 0 0rem'
           maxLength={2}
           defaultValue={closingDate}
        />
        <div style={{marginTop:'12px'}}>日</div>
      </TableWrap>
      <ButtonsWrap>
        <Button name='更新' padding='0 0 12px 0' type='button' onClick={()=>onSubmit()}/>
        <Button name='閉じる' padding='0px' onClick={onCloseFunc} />
      </ButtonsWrap>
    </div>
    </FormWrap>
  </Modal>
  )
}

SettingMenu.propTypes = {
    open: PropTypes.bool,
    closeFunc: PropTypes.func,
}

export default SettingMenu
